const Ankerslogen = ({ isMobile, ...props }: { isMobile: boolean }) => {
  return (
    <svg
      viewBox="0 0 5970 271"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1239.6 6.68848H1224.75V224.422H1239.6V6.68848Z"
        fill="#00BEFA"
      />
      <path
        d="M608.617 143.417L659.814 224.946L706.99 225.028L634.297 109.378L608.617 143.417Z"
        fill="#00BEFA"
      />
      <path
        d="M1044.03 135.216C1069.3 115.859 1080.38 95.764 1078.57 69.8452C1075.95 32.1152 1045.43 6.77051 1010.64 6.77051H910.79V225.03H950.5V135.216H997.348L1053.47 225.03H1100.32L1044.03 135.216ZM1040.09 69.9272C1040.09 86.6596 1028.36 96.5022 1010.39 96.5022H950.5V45.3207H1010.39C1033.04 45.3207 1040.09 60.9048 1040.09 69.9272Z"
        fill="#00BEFA"
      />
      <path
        d="M692.633 6.6875H642.257L538.469 144.648V6.6875H498.595V205.672C498.595 212.972 502.861 222.076 514.266 224.619C518.778 225.685 527.885 224.619 533.3 217.401C533.957 216.499 692.715 6.6875 692.715 6.6875"
        fill="#00BEFA"
      />
      <path d="M859.269 96.5H780.916V135.132H859.269V96.5Z" fill="#00BEFA" />
      <path
        d="M879.451 6.6875H723.892V205.59C723.892 216.335 732.589 225.029 743.337 225.029H879.451V186.479H763.684V45.4017H879.451V6.76952V6.6875Z"
        fill="#00BEFA"
      />
      <path
        d="M418.845 6.6875V144.648L315.058 6.6875H264.353V224.865H304.145V58.9353C351.24 121.108 423.522 216.827 424.014 217.401C429.429 224.537 438.536 225.685 443.049 224.619C454.453 221.994 458.72 212.972 458.72 205.672V6.6875H418.845Z"
        fill="#00BEFA"
      />
      <path
        d="M102.065 18.4986L0 225.029H44.4688L121.346 70.0082L198.141 225.029H242.199L140.873 19.1548C137.099 11.5268 129.386 6.6875 120.853 6.6875C112.813 6.6875 105.511 11.2807 101.983 18.4166"
        fill="#00BEFA"
      />
      <path
        d="M157.447 194.105H131.192C131.192 194.105 130.782 193.859 130.782 193.613L135.869 137.51C135.869 137.1 135.377 136.854 135.13 137.182L78.5188 211.248C78.5188 211.248 78.5188 211.904 78.847 211.904H105.184C105.184 211.904 105.594 212.15 105.594 212.396L100.507 268.499C100.507 268.909 100.999 269.155 101.245 268.827L157.857 194.761C157.857 194.761 157.857 194.105 157.529 194.105"
        fill="#00BEFA"
      />
      <path
        d="M1424.84 105.103V225.548H1392.03V105.103H1350.28V74.707H1466.89V105.103H1424.84Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M1594.29 154.966V225.558H1562.9V160.079C1562.9 142.893 1556.94 133.945 1542.59 133.945C1526.83 133.945 1516.6 145.308 1516.6 164.34V225.558H1485.21V67.1885H1516.6V120.026C1525.41 111.645 1537.9 106.39 1551.68 106.39C1578.24 106.39 1594.29 125.139 1594.29 154.824V154.966Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M1735.33 176.263H1647.41C1649.97 192.171 1660.48 200.835 1675.82 200.835C1686.61 200.835 1695.7 195.722 1700.39 187.484H1733.48C1724.82 212.624 1702.66 228.816 1675.82 228.816C1641.3 228.816 1615.45 202.255 1615.45 167.457C1615.45 132.658 1641.16 106.098 1675.82 106.098C1710.48 106.098 1735.9 133.652 1735.9 167.031C1735.9 170.013 1735.76 173.28 1735.33 176.263ZM1648.4 154.674H1704.65C1700.39 140.47 1690.02 132.658 1675.96 132.658C1661.9 132.658 1652.1 140.896 1648.4 154.674Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M1965.43 225.548H1936.31L1902.51 141.037L1869.98 225.548H1840.86L1793.28 74.707H1827.94L1857.48 174.842L1897.11 76.1274H1908.05L1948.81 174.842L1977.64 74.707H2011.73L1965.43 225.548Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M2012.02 167.457C2012.02 132.09 2038.72 106.098 2074.94 106.098C2111.16 106.098 2137.58 132.09 2137.58 167.457C2137.58 202.824 2110.59 228.816 2074.94 228.816C2039.29 228.816 2012.02 202.539 2012.02 167.457ZM2105.76 167.457C2105.76 148.708 2093.12 135.499 2074.94 135.499C2056.76 135.499 2043.98 148.566 2043.98 167.457C2043.98 186.347 2056.62 199.273 2074.94 199.273C2093.26 199.273 2105.76 186.205 2105.76 167.457Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M2230.04 138.337H2216.41C2198.79 138.337 2191.69 146.149 2191.69 165.04V225.547H2160.3V109.22H2180.61L2186.15 123.423C2194.39 113.055 2204.9 108.51 2219.81 108.51H2230.18V138.195L2230.04 138.337Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M2279.33 67.1885V225.558H2247.94V67.1885H2279.33Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M2426.33 225.555H2403.04L2399.35 215.897C2389.4 224.277 2376.9 229.106 2362.99 229.106C2327.62 229.106 2301.77 202.545 2301.77 167.463C2301.77 132.38 2327.62 106.104 2362.99 106.104C2374.77 106.104 2385.85 109.513 2394.94 115.62V67.3281H2426.33V225.697V225.555ZM2397.36 167.463C2397.36 149.14 2383.72 135.505 2365.4 135.505C2347.08 135.505 2333.73 149.14 2333.73 167.463C2333.73 185.785 2347.36 199.279 2365.4 199.279C2383.44 199.279 2397.36 185.501 2397.36 167.463Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M2471.78 102.836H2453.74V69.1738H2487.83V100.137C2487.83 121.869 2474.77 134.794 2455.59 136.925V121.443C2467.38 119.88 2471.93 111.784 2471.93 102.694L2471.78 102.836Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M2501.47 187.2H2532.01C2532.15 197.569 2540.25 202.682 2551.47 202.682C2560.27 202.682 2568.08 198.847 2568.08 191.035C2568.08 183.223 2558 180.666 2545.64 178.536C2527.18 175.553 2503.46 170.582 2503.46 143.027C2503.46 121.012 2522.21 105.956 2550.47 105.956C2578.74 105.956 2596.78 121.438 2597.06 144.732H2567.09C2567.09 135.499 2560.56 130.954 2549.62 130.954C2539.68 130.954 2534.14 135.499 2534.14 142.175C2534.14 149.987 2544.08 151.691 2556.15 153.822C2575.04 157.231 2599.19 161.35 2599.19 189.615C2599.19 213.477 2579.73 228.816 2550.47 228.816C2521.21 228.816 2501.75 212.198 2501.61 187.2H2501.47Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3532.93 127.118L3487.9 225.406H3479.95L3434.92 127.118L3420.01 225.548H3386.63L3410.35 74.707H3443.16L3483.92 167.172L3524.83 74.707H3557.64L3581.08 225.548H3547.84L3532.93 127.118Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3595 167.457C3595 132.09 3621.7 106.098 3657.92 106.098C3694.14 106.098 3720.56 132.09 3720.56 167.457C3720.56 202.824 3693.57 228.816 3657.92 228.816C3622.27 228.816 3595 202.539 3595 167.457ZM3688.6 167.457C3688.6 148.708 3675.96 135.499 3657.78 135.499C3639.6 135.499 3626.81 148.566 3626.81 167.457C3626.81 186.347 3639.45 199.273 3657.78 199.273C3676.1 199.273 3688.6 186.205 3688.6 167.457Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3867.56 167.465C3867.56 202.548 3841.85 228.824 3806.34 228.824C3792.28 228.824 3779.64 224.137 3769.98 215.899L3766.29 225.558H3743V67.1885H3774.39V115.48C3783.48 109.515 3794.27 105.964 3806.34 105.964C3841.85 105.964 3867.56 131.956 3867.56 167.323V167.465ZM3835.46 167.465C3835.46 149.143 3822.11 135.507 3803.79 135.507C3785.46 135.507 3772.11 149.143 3772.11 167.465C3772.11 185.788 3785.75 199.139 3803.79 199.139C3821.83 199.139 3835.46 185.504 3835.46 167.465Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3921.68 64.4844V93.7436H3890.29V64.4844H3921.68ZM3921.68 109.225V225.552H3890.29V109.225H3921.68Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3983.18 67.1885V225.558H3951.79V67.1885H3983.18Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M4125.64 176.263H4037.72C4040.28 192.171 4050.79 200.835 4066.13 200.835C4076.92 200.835 4086.01 195.722 4090.7 187.484H4123.79C4115.13 212.624 4092.97 228.816 4066.13 228.816C4031.61 228.816 4005.76 202.255 4005.76 167.457C4005.76 132.658 4031.47 106.098 4066.13 106.098C4100.78 106.098 4126.21 133.652 4126.21 167.031C4126.21 170.013 4126.07 173.28 4125.64 176.263ZM4038.57 154.674H4094.82C4090.56 140.47 4080.19 132.658 4066.13 132.658C4052.07 132.658 4042.26 140.896 4038.57 154.674Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M4193.53 150.417C4193.53 105.392 4227.19 71.5879 4271.22 71.5879C4307.87 71.5879 4337.13 95.8759 4344.23 131.669H4311.56C4305.31 113.772 4290.26 102.552 4271.22 102.552C4245.8 102.552 4226.48 123.289 4226.48 150.417C4226.48 177.546 4245.94 197.857 4271.22 197.857C4291.11 197.857 4306.31 185.784 4311.7 166.609H4344.66C4337.7 203.822 4308.44 228.821 4271.22 228.821C4227.05 228.821 4193.53 195.016 4193.53 150.417Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M4475.33 154.966V225.558H4443.94V160.079C4443.94 142.893 4437.98 133.945 4423.63 133.945C4407.86 133.945 4397.64 145.308 4397.64 164.34V225.558H4366.25V67.1885H4397.64V120.026C4406.44 111.645 4418.94 106.39 4432.72 106.39C4459.28 106.39 4475.33 125.139 4475.33 154.824V154.966Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M4622.62 225.408H4597.91L4595.35 215.039C4585.41 223.703 4572.34 228.816 4557.71 228.816C4522.63 228.816 4496.78 202.54 4496.78 167.173C4496.78 131.806 4522.63 105.956 4557.71 105.956C4572.62 105.956 4585.97 111.069 4595.78 120.16L4599.18 108.939H4622.62V225.266V225.408ZM4591.8 167.173C4591.8 148.851 4578.45 135.215 4560.12 135.215C4541.8 135.215 4528.45 148.993 4528.45 167.173C4528.45 185.354 4541.8 199.131 4560.12 199.131C4578.45 199.131 4591.8 185.496 4591.8 167.173Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M4722.47 138.337H4708.84C4691.22 138.337 4684.12 146.149 4684.12 165.04V225.547H4652.73V109.22H4673.04L4678.58 123.423C4686.82 113.055 4697.33 108.51 4712.25 108.51H4722.61V138.195L4722.47 138.337Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M4793.06 270.858C4761.67 270.858 4739.23 254.666 4733.83 228.248H4765.08C4768.49 238.616 4780.85 244.014 4792.5 244.014C4808.4 244.014 4821.61 233.645 4821.61 216.601V212.34C4812.38 219.015 4801.16 222.708 4788.38 222.708C4755.85 222.708 4730.57 197.284 4730.57 164.474C4730.57 131.664 4755.85 106.098 4788.38 106.098C4803.43 106.098 4817.07 111.637 4827.15 121.011L4832.12 109.364H4852.58V212.198C4852.58 248.559 4829.99 271 4793.06 271V270.858ZM4821.75 164.332C4821.75 147.146 4809.54 134.363 4792.07 134.363C4774.6 134.363 4762.53 147.146 4762.53 164.332C4762.53 181.518 4774.74 194.443 4792.07 194.443C4809.4 194.443 4821.75 181.802 4821.75 164.332Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M4914.08 64.4844V93.7436H4882.69V64.4844H4914.08ZM4914.08 109.225V225.552H4882.69V109.225H4914.08Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5053.41 155.103V225.553H5022.02V160.075C5022.02 142.604 5015.35 133.94 5001.71 133.94C4985.52 133.94 4975.72 145.587 4975.72 164.336V225.553H4944.33V109.226H4965.92L4972.17 123.714C4980.97 113.203 4994.75 106.527 5010.66 106.527C5037.22 106.527 5053.56 125.702 5053.56 155.245L5053.41 155.103Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5137.21 270.858C5105.82 270.858 5083.38 254.666 5077.98 228.248H5109.23C5112.64 238.616 5125 244.014 5136.65 244.014C5152.55 244.014 5165.76 233.645 5165.76 216.601V212.34C5156.53 219.015 5145.31 222.708 5132.53 222.708C5100 222.708 5074.86 197.284 5074.86 164.474C5074.86 131.664 5100 106.098 5132.53 106.098C5147.58 106.098 5161.22 111.637 5171.3 121.011L5176.27 109.364H5196.73V212.198C5196.73 248.559 5174.14 271 5137.21 271V270.858ZM5165.76 164.332C5165.76 147.146 5153.41 134.363 5136.08 134.363C5118.75 134.363 5106.53 147.146 5106.53 164.332C5106.53 181.518 5118.89 194.443 5136.08 194.443C5153.26 194.443 5165.76 181.802 5165.76 164.332Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5391.88 182.086C5391.88 206.231 5370.58 225.548 5344.44 225.548H5280.24V74.707H5342.74C5368.59 74.707 5388.05 91.3251 5388.05 113.483C5388.05 126.408 5381.51 138.481 5371 146.009C5384.35 152.968 5391.88 166.036 5391.88 181.943V182.086ZM5339.61 102.546H5312.48V134.646H5339.61C5349.98 134.646 5356.37 127.97 5356.37 118.738C5356.37 109.506 5349.84 102.546 5339.61 102.546ZM5359.21 178.677C5359.21 169.018 5352.11 161.917 5341.32 161.917H5312.48V195.721H5341.32C5352.11 195.721 5359.21 188.619 5359.21 178.677Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5486.05 138.337H5472.42C5454.8 138.337 5447.7 146.149 5447.7 165.04V225.547H5416.31V109.22H5436.62L5442.16 123.423C5450.4 113.055 5460.91 108.51 5475.83 108.51H5486.19V138.195L5486.05 138.337Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5619.71 225.408H5594.99L5592.44 215.039C5582.49 223.703 5569.43 228.816 5554.8 228.816C5519.71 228.816 5493.86 202.54 5493.86 167.173C5493.86 131.806 5519.71 105.956 5554.8 105.956C5569.71 105.956 5583.06 111.069 5592.86 120.16L5596.27 108.939H5619.71V225.266V225.408ZM5589.03 167.173C5589.03 148.851 5575.68 135.215 5557.35 135.215C5539.03 135.215 5525.68 148.993 5525.68 167.173C5525.68 185.354 5539.03 199.131 5557.35 199.131C5575.68 199.131 5589.03 185.496 5589.03 167.173Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5759.04 155.103V225.553H5727.65V160.075C5727.65 142.604 5720.98 133.94 5707.34 133.94C5691.15 133.94 5681.35 145.587 5681.35 164.336V225.553H5649.96V109.226H5671.55L5677.8 123.714C5686.6 113.203 5700.38 106.527 5716.43 106.527C5742.99 106.527 5759.33 125.702 5759.33 155.245L5759.04 155.103Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5904.91 225.555H5881.62L5877.92 215.897C5867.98 224.277 5855.48 229.106 5841.56 229.106C5806.2 229.106 5780.35 202.545 5780.35 167.463C5780.35 132.38 5806.2 106.104 5841.56 106.104C5853.35 106.104 5864.43 109.513 5873.52 115.62V67.3281H5904.91V225.697V225.555ZM5875.79 167.463C5875.79 149.14 5862.16 135.505 5843.84 135.505C5825.51 135.505 5812.16 149.14 5812.16 167.463C5812.16 185.785 5825.8 199.279 5843.84 199.279C5861.87 199.279 5875.79 185.501 5875.79 167.463Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M5965.85 98.8527L5955.19 107.659L5946.67 97.2903L5938.29 107.659L5927.64 98.8527L5935.45 89.7625L5924.23 85.9275L5928.92 72.8603L5939.85 76.9793V65.1904H5953.77V76.9793L5964.85 72.8603L5969.54 85.9275L5958.32 89.7625L5966.13 98.8527H5965.85Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3147.3 219.872L3154.97 174.989C3155.26 173 3153.98 171.58 3151.99 171.58H3107.39C3105.4 171.58 3103.98 172.858 3103.7 174.989L3096.03 219.872C3095.74 221.86 3097.02 223.281 3099.01 223.281H3143.61C3145.6 223.281 3147.02 222.003 3147.3 219.872Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3280.81 220.017L3318.88 5.4026C3319.16 3.41411 3317.89 2.13574 3315.9 2.13574H3272.01C3270.02 2.13574 3268.17 2.84596 3266.18 4.12428L3222.3 32.1051C3220.73 33.3835 3220.02 34.6618 3219.74 36.6503L3211.93 82.5276C3211.22 85.0842 3213.21 85.7944 3215.19 84.5161L3255.82 59.5179H3256.53L3227.98 220.16C3227.69 222.148 3228.97 223.426 3230.96 223.426H3277.41C3279.39 223.426 3280.67 222.148 3280.96 220.16L3280.81 220.017Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M2897.46 2.69454C2897.46 2.69454 2896.61 2.12639 2895.9 2.12639H2851.87C2850.02 2.12639 2849.46 3.68877 2849.46 4.39894L2826.3 134.787H2825.45L2780.85 4.54101C2780.14 2.83659 2779.01 1.98438 2777.02 1.98438H2730.29C2728.44 1.98438 2727.87 3.54676 2727.87 4.25693L2689.38 221.144C2689.38 221.144 2689.38 221.997 2689.67 222.423C2689.95 222.849 2690.52 222.991 2691.23 222.991H2735.26C2736.25 222.991 2737.11 222.139 2737.39 220.718L2760.54 90.1881H2761.68L2806.28 220.434C2806.7 222.139 2807.84 222.849 2809.83 222.849H2856.84C2858.69 222.849 2859.11 221.428 2859.26 220.576L2897.75 3.68878C2897.75 3.68878 2897.75 2.69456 2897.46 2.26845V2.69454Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
      <path
        d="M3014.22 0C2975.72 0 2945.33 15.3398 2928.14 50.8485C2916.35 74.8524 2906.7 135.643 2906.7 156.807C2906.7 201.974 2935.53 225.268 2979.13 225.268C3017.2 225.268 3047.59 209.928 3065.21 174.419C3077 150.415 3086.65 89.6241 3086.65 68.4609C3086.65 23.2937 3057.82 0 3014.22 0ZM2989.22 201.264H2989.08V133.371H2953.28C2953.28 133.371 2953.28 133.229 2953.28 133.087L3004.13 24.0039H3004.27V91.7546H3040.21C3040.21 91.7546 3040.21 91.7547 3040.21 91.8967L2989.22 201.122V201.264Z"
        fill="#00BEFA"
        fill-opacity="0.980392"
      />
    </svg>
  )
}

export default Ankerslogen
